/* All component-scoped CSS for the Sales Dashboard, injected via <style>{CSS}</style> in MyDashboard.jsx (kept as a JS string, exactly as in the original file, to avoid any change in how/when styles are applied). */
export const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

:root {
  --sd-primary: #4F46E5;
  --sd-primary-soft: #EEF2FF;
  --sd-radius: 18px;
}

.sd-root {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  background: #f3f3f3;
  height: 100%;
  min-height: 0;
  color: #3B4457;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.sd-header-bar {
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 30;
  max-width: 1680px;
  width: 100%;
  margin: 0 auto;
}
.sd-scroll-area {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: 8px;
}
.sd-shell { max-width: 1680px; margin: 0 auto;}

/* ---------------- Header ---------------- */
.sd-header { display: flex; align-items: flex-start; justify-content: space-between; flex-wrap: wrap; gap: 16px; margin-bottom: 12px; border-bottom: 1px solid #dadae3 }
.sd-header-title { font-size: 27px; font-weight: 800; color: #0F172A; margin: 0 0 4px; letter-spacing: -0.02em; display: flex; align-items: center; gap: 10px; }
.sd-header-icon { color: var(--sd-primary); }
.sd-header-subtitle { font-size: 13.5px; color: #8896A8; margin: 0; }
.sd-header-actions { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }

.sd-search {
  display: flex; align-items: center; gap: 8px;
  background: rgba(255,255,255,0.7); backdrop-filter: blur(10px);
  border: 1px solid #E7EBF3; border-radius: 12px; padding: 9px 14px;
  color: #8896A8; min-width: 240px;
}
.sd-search input { border: none; outline: none; background: transparent; font-size: 13px; width: 100%; color: #3B4457; }

.sd-filter-pos { position: relative; }
.sd-filter-btn {
  display: flex; align-items: center; gap: 8px;
  background: rgba(255,255,255,0.75); backdrop-filter: blur(10px);
  border: 1px solid #E7EBF3; color: #3B4457; font-size: 13px; font-weight: 500;
  padding: 9px 14px; border-radius: 12px; cursor: pointer;
  transition: border-color .15s ease, box-shadow .15s ease;
}
.sd-filter-btn:hover { border-color: var(--sd-primary); box-shadow: 0 0 0 3px var(--sd-primary-soft); }
.sd-caret { transition: transform .15s ease; color: #8896A8; }
.sd-caret-open { transform: rotate(180deg); }

.sd-dropdown {
  position: absolute; top: calc(100% + 6px); left: 0; min-width: 190px; z-index: 40;
  background: #fff; border: 1px solid #E7EBF3; border-radius: 12px;
  box-shadow: 0 16px 40px -12px rgba(15,23,42,0.22); padding: 6px; overflow: hidden;
}
.sd-dropdown-anim { animation: sdDropdownIn .15s ease; }
@keyframes sdDropdownIn {
  from { opacity: 0; transform: translateY(-6px); }
  to { opacity: 1; transform: translateY(0); }
}
.sd-dropdown-item { padding: 9px 10px; font-size: 13px; border-radius: 8px; cursor: pointer; color: #3B4457; }
.sd-dropdown-item:hover { background: var(--sd-primary-soft); color: var(--sd-primary); }
.sd-dropdown-item-active { background: var(--sd-primary-soft); color: var(--sd-primary); font-weight: 700; }

.sd-icon-btn {
  position: relative; width: 38px; height: 38px; border-radius: 12px; border: 1px solid #E7EBF3;
  background: rgba(255,255,255,0.75); color: #3B4457; display: flex; align-items: center; justify-content: center;
  cursor: pointer; transition: border-color .15s ease;
}
.sd-icon-btn:hover { border-color: var(--sd-primary); color: var(--sd-primary); }
.sd-icon-btn-sm { width: 30px; height: 30px; border-radius: 8px; }
.sd-icon-dot { position: absolute; top: 7px; right: 8px; width: 7px; height: 7px; border-radius: 50%; background: #EF4444; border: 1.5px solid #fff; }

.sd-export-btn {
  display: flex; align-items: center; gap: 8px;
  background: linear-gradient(135deg, #4F46E5, #8B7CF6);
  color: #fff; border: none; font-size: 13px; font-weight: 600;
  padding: 10px 18px; border-radius: 12px; cursor: pointer;
  box-shadow: 0 8px 20px -8px rgba(79,70,229,0.6);
  transition: transform .15s ease;
}
.sd-export-btn:hover { transform: translateY(-1px); }
.sd-export-btn:active { transform: scale(0.97); }

/* ---------------- Glass card shell ---------------- */
.sd-card {
  background: #fff;
  backdrop-filter: blur(14px);
  border: 1px solid #0000002d;
  border-radius: 10px;
  display: flex; flex-direction: column;
}
.sd-card-head { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; padding: 15px 15px 4px; flex-wrap: wrap; border-bottom: 1px solid #7474742e; }
.sd-card-head-left { display: flex; align-items: center; gap: 12px; }
.sd-card-head-right { display: flex; align-items: center; gap: 10px; flex-shrink: 0; }
.sd-card-head-icon { width: 34px; height: 34px; border-radius: 10px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; order: 2; }
.sd-card-title { font-size: 16px; font-weight: 400; line-height:1.5rem }
.sd-card-subtitle { font-size: 12.5px; color: #8896A8; margin-top: 2px; }
.sd-card-body { padding: 16px 22px 22px; flex: 1; }
.sd-card-body1 { padding: 16px 22px 22px; flex: 1; }
.sd-card1-body { flex: 1; max-height:400px }
.sd-legend-inline { display: flex; gap: 14px; font-size: 12px; color: #8896A8; }
.sd-legend-inline span { display: flex; align-items: center; gap: 6px; }
.sd-legend-inline i { width: 8px; height: 8px; border-radius: 50%; display: inline-block; }
.sd-legend-block { margin-bottom: 6px; }

/* ---------------- Range tabs ---------------- */
.sd-range-dd-pos { position: relative; flex-shrink: 0; }
.sd-range-dd-btn {
  display: flex; align-items: center; gap: 7px; white-space: nowrap;
  background: #F1F4F9; border: 1px solid transparent; color: #3B4457;
  font-size: 12px; font-weight: 600; padding: 7px 11px; border-radius: 9px; cursor: pointer;
  transition: border-color .15s ease, background .15s ease;
}
.sd-range-dd-btn:hover { border-color: var(--sd-primary); background: #fff; }
.sd-range-dd-menu { left: auto; right: 0; min-width: 150px; }

/* ---------------- KPI tiles ---------------- */
.sd-kpi {
  background: rgba(255,255,255,0.82); backdrop-filter: blur(14px);
  border: 1px solid rgba(231,235,243,0.9); border-radius: var(--sd-radius);
  padding: 16px 16px 14px; box-shadow: 0 1px 2px rgba(15,23,42,0.03), 0 14px 32px -20px rgba(15,23,42,0.16);
}
.sd-kpi-top { display: flex; align-items: center; justify-content: space-between; margin-bottom: 14px; }
.sd-kpi-icon { width: 36px; height: 36px; border-radius: 11px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.sd-kpi-trend { display: flex; align-items: center; gap: 3px; font-size: 12px; font-weight: 700; }
.sd-kpi-value { font-size: 21px; font-weight: 200; color: #0F172A; letter-spacing: -0.02em; }
.sd-kpi-label { font-size: 12.5px; font-weight: 600; color: #3B4457; margin-top: 2px; }
.sd-kpi-caption { font-size: 11.5px; color: #8896A8; margin-top: 3px; margin-bottom: 8px; }
.sd-kpi-row { display: flex; align-items: center; gap: 14px; }
.sd-kpi-compact { padding: 16px 12px; text-align: center; }
.sd-mini-gauge { display: flex; flex-direction: column; justify-content: center; }
.sd-mini-gauge-lg { width: 50%;}

.sd-kpi-sm { padding: 10px 12px; border-radius: 12px; box-shadow: none; background: #FAFBFF; }
.sd-kpi-sm.sd-kpi-row { gap: 10px; }
.sd-kpi-sm .sd-kpi-icon { width: 30px; height: 30px; border-radius: 9px; }
.sd-kpi-sm .sd-kpi-value { font-size: 16px; }
.sd-kpi-sm .sd-kpi-label { font-size: 11px; }
.sd-kpi-sm.sd-kpi-compact { padding: 12px 8px; }
.sd-kpi-sm.sd-kpi-compact .sd-kpi-icon { margin-bottom: 8px !important; }
.sd-kpi-trend-mini { font-size: 11px; font-weight: 300; margin-top: 5px; display: inline-flex; align-items: center; gap: 3px; }

.sd-kpi-stack { padding: 0; overflow: hidden; display: flex; flex-direction: column; }
.sd-kpi-stack-row { display: flex; align-items: center; gap: 14px; padding: 14px 18px; flex: 1; }
.sd-kpi-stack-row-div { border-top: 1px dashed #E2E7F0; }

.sd-outreach-list { display: flex; flex-direction: column; height: 100%; justify-content: space-between; }
.sd-outreach-row { display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 10px 0; border-top: 1px dashed #E2E7F0; }
.sd-outreach-row:first-child { border-top: none; padding-top: 2px; }
.sd-outreach-left { display: flex; align-items: center; gap: 10px; }
.sd-outreach-trend { font-size: 11.5px; font-weight: 300;margin-top:2.1rem; text-align: right; white-space: nowrap; }

.sd-personal-kpi-list { display: flex; align-items: stretch; justify-content: space-between; height: 100%; }
.sd-personal-kpi-item { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; padding: 8px 10px; border-left: 1px dashed #E2E7F0; }

.sd-activity-grid { display: flex; flex-direction: column; height: 100%; justify-content: space-between; }
.sd-activity-row { display: flex; align-items: flex-start; justify-content: space-between; gap: 8px; }
.sd-activity-row-div { border-bottom: 1px dashed #E2E7F0; padding-bottom: 14px; margin-bottom: 14px; }
.sd-activity-item { flex: 1; display: flex; flex-direction: column; align-items: center; text-align: center; }
.sd-personal-kpi-item:first-child { border-left: none; padding-left: 0; }

/* ---------------- Pipeline stage grid ---------------- */
/* No forced height: rows only take the space their content needs (fixes a
   2-stage pipeline stretching to fill the whole card). When there are more
   stages than fit comfortably (6+), the grid scrolls internally instead of
   clipping data (fixes the 8-stage "Sales" pipeline losing rows). */
.sd-pipeline-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: min-content;
  align-content: start;
  gap: 12px;
}
.sd-pipeline-cell { background: #FAFBFF; border: 1px solid #EEF1F6; border-radius: 12px; padding: 22px 14px; display: flex; flex-direction: column; justify-content: center; min-width: 0; }
.sd-pipeline-cell-top { display: flex; align-items: center; justify-content: space-between; margin-bottom: 9px; gap: 8px; }
.sd-pipeline-icon { width: 28px; height: 28px; border-radius: 8px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.sd-pipeline-value { font-size: 15px; font-weight: 800; color: #0F172A; }
.sd-pipeline-cell-top h3 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.sd-pipeline-label {
  font-size: 11.5px;
  font-weight: 600;
  color: #3B4457;
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ---------------- Radial / target ---------------- */
.sd-radial-wrap { display: flex; flex-direction: row; align-items: center; gap: 8px; }
.sd-radial-center { position: absolute; inset: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; pointer-events: none; }
.sd-radial-pct { font-size: 26px; font-weight: 800; color: #0F172A; }
.sd-radial-caption { font-size: 12px; color: #8896A8; }

.recharts-wrapper:focus,
.recharts-wrapper *:focus,
.recharts-surface:focus { outline: none !important; }

.sd-gauge-svg { position: absolute; inset: 0; width: 100%; height: 100%; }
.sd-target-stats { width: 100%; display: flex; flex-direction: column; gap: 10px; margin-top: 6px; }
.sd-target-stat { display: flex; align-items: center; gap: 8px; font-size: 13px; }
.sd-target-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.sd-target-label { color: #8896A8; flex: 1; }
.sd-target-value { font-weight: 700; color: #0F172A; }
.sd-achievement-badge { margin-top: 4px; font-size: 12px; font-weight: 600; color: #16A34A; background: #ECFDF3; padding: 8px 10px; border-radius: 10px; text-align: center; }

/* ---------------- Pie legend ---------------- */
.sd-pie-wrap { display: flex; flex-direction: column; }
.sd-pie-legend { display: flex; flex-direction: column; gap: 8px; margin-top: 4px; }
.sd-pie-legend-row { display: flex; align-items: center; gap: 8px; font-size: 12.5px; padding: 3px 4px; border-radius: 6px; transition: background .15s ease; min-width: 0; }
.sd-pie-legend-row:hover { background: #F6F8FC; }
.sd-pie-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.sd-pie-legend-name {
  color: #3B4457;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.sd-pie-legend-value { font-weight: 700; color: #0F172A; flex-shrink: 0; }

.sd-table-wrap { 
  max-height: 360px; 
  overflow-y: auto; 
  overflow-x: auto; 
  position: relative;
  border-radius: 8px; 
}

/* Pipeline Distribution: cap visible cards at 6 (3 rows x 2 cols), scroll for the rest */
.sd-pipeline-scroll {
  max-height: 336px;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  padding-right: 4px;
}

.sd-table { 
  width: 100%; 
  border-collapse: collapse;
  font-size: 13px; 
}

.sd-table thead {
  position: sticky;
  top: 0;
  z-index: 20;
}

.sd-table thead th { 
  position: sticky; 
  top: 0; 
  background-color: #ffffff !important;
  z-index: 20; 
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.08);
  text-align: left; 
  font-size: 11px; 
  text-transform: uppercase; 
  letter-spacing: .04em; 
  color: #8896A8; 
  font-weight: 700; 
  padding: 12px; 
  white-space: nowrap; 
}

.sd-table tbody tr {
  background-color: #ffffff;
}

.sd-table tbody td { 
  padding: 14px 12px;
  border-bottom: 1px solid #EEF1F6; 
  white-space: nowrap; 
  vertical-align: middle; 
}

.sd-table tbody tr:hover { 
  background-color: #FAFBFF; 
}

.sd-table-strong { font-weight: 600; color: #0F172A; }
.sd-table-muted { color: #8896A8; }

.sd-badge { display: inline-flex; align-items: center; font-size: 12px; font-weight: 700; padding: 4px 10px; border-radius: 999px; }
.sd-score { display: inline-flex; align-items: center; gap: 6px; font-weight: 700; font-size: 13px; color: #0F172A; }
.sd-score-dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }
.sd-rank-badge { display: inline-flex; align-items: center; justify-content: center; width: 22px; height: 22px; border-radius: 999px; font-size: 11px; font-weight: 800; color: #8896A8; background: #EEF1F6; }
.sd-rank-top { color: #fff; box-shadow: 0 3px 8px -3px rgba(15,23,42,0.35); }
.sd-avatar { width: 30px; height: 30px; border-radius: 10px; display: inline-flex; align-items: center; justify-content: center; font-size: 11.5px; font-weight: 700; flex-shrink: 0; }

.sd-prob-track { height: 6px; border-radius: 999px; background: #EEF1F6; overflow: hidden; width: 70px; display: inline-block; vertical-align: middle; margin-right: 6px; }
.sd-prob-fill { height: 100%; border-radius: 999px; transition: width .5s ease; }

.sd-quick-actions { display: flex; gap: 6px; }
.sd-quick-actions button { width: 28px; height: 28px; border-radius: 8px; border: 1px solid #E7EBF3; background: #fff; color: #4F46E5; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: background .15s ease; }
.sd-quick-actions button:hover { background: var(--sd-primary-soft); }

/* ---------------- Tooltip ---------------- */
.sd-tooltip { background: #fff; color: #0F172A; border: 1px solid #E7EBF3; border-radius: 10px; padding: 10px 12px; font-size: 12px; box-shadow: 0 10px 30px rgba(15,23,42,0.15); min-width: 140px; }
.sd-tooltip-label { font-weight: 700; margin-bottom: 6px; color: #0F172A; opacity: .9; }
.sd-tooltip-row { display: flex; align-items: center; gap: 6px; justify-content: space-between; }
.sd-tooltip-swatch { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }
.sd-tooltip-name { opacity: .65; margin-right: 8px; color: #3B4457; }
.sd-tooltip-value { font-weight: 700; margin-left: auto; color: #0F172A; }

/* ---------------- Activities ---------------- */
.sd-activity-grid { display: flex; flex-direction: column; gap: 16px; }

/* ---------------- Custom thin scrollbar (webkit) ---------------- */
.saurabhscrollbar, .sd-table-wrap, .sd-pipeline-scroll { transition: scrollbar-color .15s ease; scrollbar-width: thin; }
.saurabhscrollbar::-webkit-scrollbar, .sd-table-wrap::-webkit-scrollbar, .sd-pipeline-scroll::-webkit-scrollbar { width: 6px; height: 6px; }
.saurabhscrollbar::-webkit-scrollbar-track, .sd-table-wrap::-webkit-scrollbar-track, .sd-pipeline-scroll::-webkit-scrollbar-track { background: transparent; }
.saurabhscrollbar::-webkit-scrollbar-thumb, .sd-table-wrap::-webkit-scrollbar-thumb, .sd-pipeline-scroll::-webkit-scrollbar-thumb { background-color: #e5e9f2; border-radius: 999px; }
.saurabhscrollbar:hover::-webkit-scrollbar-thumb, .sd-table-wrap:hover::-webkit-scrollbar-thumb, .sd-pipeline-scroll:hover::-webkit-scrollbar-thumb { background-color: #cbd3e1; }
.sd-activity { display: flex; align-items: center; gap: 12px; }
.sd-activity-icon { width: 34px; height: 34px; border-radius: 11px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.sd-activity-info { flex: 1; }
.sd-activity-top { display: flex; align-items: baseline; justify-content: space-between; margin-bottom: 6px; }
.sd-activity-label { font-size: 13px; font-weight: 600; color: #3B4457; }
.sd-activity-count { font-size: 13px; font-weight: 700; color: #0F172A; }
.sd-activity-total { font-weight: 500; color: #8896A8; }
.sd-activity-track { height: 6px; border-radius: 999px; background: #EEF1F6; overflow: hidden; }
.sd-activity-fill { height: 100%; border-radius: 999px; transition: width .7s ease; }

/* ---------------- AI Actions ---------------- */
.sd-actions-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 16px; }
.sd-action { background: rgba(251,252,254,0.9); border: 1px solid #E7EBF3; border-left: 4px solid; border-radius: 14px; padding: 16px; display: flex; flex-direction: column; gap: 10px; transition: transform .15s ease, box-shadow .15s ease; }
.sd-action:hover { transform: translateY(-3px); box-shadow: 0 10px 24px -14px rgba(15,23,42,0.22); }
.sd-action-top { display: flex; align-items: center; justify-content: space-between; }
.sd-action-icon { width: 32px; height: 32px; border-radius: 10px; display: flex; align-items: center; justify-content: center; }
.sd-action-priority { font-size: 10.5px; font-weight: 800; text-transform: uppercase; letter-spacing: .04em; padding: 3px 9px; border-radius: 999px; }
.sd-action-title { font-size: 14px; font-weight: 700; color: #0F172A; }
.sd-action-detail { font-size: 12.5px; color: #8896A8; line-height: 1.5; flex: 1; }
.sd-action-confidence { display: flex; align-items: center; gap: 8px; font-size: 11.5px; color: #8896A8; font-weight: 600; }
.sd-action-confidence .sd-prob-track { width: 100%; flex: 1; }
.sd-action-btns { display: flex; align-items: center; gap: 6px; margin-top: 2px; }
.sd-action-icon-btn { width: 28px; height: 28px; border-radius: 8px; border: 1px solid #E7EBF3; background: #fff; color: #3B4457; display: flex; align-items: center; justify-content: center; cursor: pointer; }
.sd-action-icon-btn:hover { border-color: var(--sd-primary); color: var(--sd-primary); }
.sd-action-btn { align-self: center; background: none; border: none; font-size: 12.5px; font-weight: 700; padding: 0; cursor: pointer; }
.sd-action-btn:hover { text-decoration: underline; }

/* ---------------- Regional map ---------------- */
.sd-map-wrap { position: relative; display: flex; flex-direction: column; gap: 12px; }
.sd-gmap-box { width: 100%; height: 240px; border-radius: 14px; overflow: hidden; border: 1px solid #E7EBF3; }
.sd-gmap-fallback { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background: #F6F8FC; color: #8896A8; font-size: 13px; }
.sd-map-tooltip { position: absolute; top: 8px; right: 8px; background: #0F172A; color: #fff; border-radius: 10px; padding: 10px 12px; font-size: 12px; min-width: 140px; box-shadow: 0 10px 30px rgba(15,23,42,0.3); }
.sd-map-tooltip .sd-tooltip-row { color: #cbd5e1; }
.sd-map-list { display: flex; flex-direction: column; gap: 8px; }
.sd-map-list-row { display: flex; align-items: center; font-size: 12.5px; cursor: pointer; }
.sd-map-list-name { width: 100px; color: #3B4457; font-weight: 600; }
.sd-map-list-value { font-weight: 700; color: #0F172A; width: 50px; text-align: right; }

@media (max-width: 575px) {
  .sd-header-bar { padding: 18px 14px 0; }
  .sd-shell { padding: 18px 14px 40px; }
  .sd-header-title { font-size: 21px; }
  .sd-search { min-width: 0; flex: 1; }
}

`;
